import React from "react";
import VideoBarPersonMicOn from "graphics/icons/SideVideo/VideoBarPersonMicOn";
import VideoBarPersonMicOff from "graphics/icons/SideVideo/VideoBarPersonMicOff";
import VideoBarPersonMutedForMe from "graphics/icons/SideVideo/VideoBarPersonMutedForMe";
import {
  GRID_VIEW,
  SIDE_LARGE_EMPTY,
  SIDE_LARGE_VIEW,
  SIDE_SMALL_VIEW,
  SIDE_MINI_VIEW,
} from "slices/spaceMediaSlice";
import VideoBarPersonCamOn from "graphics/icons/SideVideo/VideoBarPersonCamOn";
import VideoBarPersonShareOn from "graphics/icons/SideVideo/VideoBarPersonShareOn";

const RemoteMediaStatus = ({
  mutedForMe,
  micOn,
  camOn,
  share,
  visual,
  admin,
  membersMuted,
}) => {
  let showMicOn =
    micOn && (visual === SIDE_MINI_VIEW || visual === SIDE_SMALL_VIEW);
  let showMicOff = !micOn || (!admin && membersMuted);
  let showMuted = mutedForMe;
  let showSharing =
    share && (visual === SIDE_SMALL_VIEW || visual === SIDE_MINI_VIEW);
  let showCamOn =
    camOn &&
    ((visual === GRID_VIEW && share) ||
      ((visual === SIDE_LARGE_VIEW || visual === SIDE_LARGE_EMPTY) && share) ||
      visual === SIDE_SMALL_VIEW ||
      visual === SIDE_MINI_VIEW);

  return (
    <div className={`remote-media-status`}>
      {showCamOn && <VideoBarPersonCamOn />}
      {showSharing && <VideoBarPersonShareOn />}
      {showMicOff && <VideoBarPersonMicOff />}
      {showMicOn && <VideoBarPersonMicOn />}
      {showMuted && <VideoBarPersonMutedForMe />}
    </div>
  );
};
export default RemoteMediaStatus;
